export default __webpack_public_path__ + "static/media/spa-image-13.63f283ec.jpg";